module.exports = __webpack_public_path__ + "img/covid19-vaccine-waste.639d1c9c.jpg";